import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { DashboardItemComponent } from './component/dashboard-item/dashboard-item.component';
import { DashboardHeaderComponent } from './component/dashboard-header/dashboard-header.component';
import { DashboardMenuDirective } from './directive/dashboard-menu.directive';
import { UpdatesService } from './service/updates.service';
import { CommonModule } from '../common/common.module';
import { AutoActionService } from './service/auto-action.service';
import { DashboardMenuComponent } from './component/dashboard-menu/dashboard-menu.component';
import { DashboardMenuSwitcherComponent } from './component/dashboard-menu-switcher/dashboard-menu-switcher.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DashboardNewMenuComponent } from './component/dashboard-new-menu/dashboard-new-menu.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { DashboardNewMenuItemComponent } from './component/dashboard-new-menu-item/dashboard-new-menu-item.component';
import { DashboardNewMenuHogiaComponent } from './component/dashboard-new-menu-hogia/dashboard-new-menu-hogia.component';

@NgModule({
  imports: [CommonModule, CoreModule, MatSlideToggleModule, MatExpansionModule, MatIconModule],
  declarations: [
    DashboardComponent,
    DashboardHeaderComponent,
    DashboardItemComponent,
    DashboardMenuDirective,
    DashboardMenuComponent,
    DashboardNewMenuComponent,
    DashboardNewMenuHogiaComponent,
    DashboardMenuSwitcherComponent,
    DashboardNewMenuItemComponent,
  ],
  providers: [UpdatesService, AutoActionService],
  exports: [DashboardComponent],
})
export class DashboardModule {}
